export class Color {
    R: number;
    G: number;
    B: number;

    constructor(R: number, G: number, B: number) {
        this.R = R;
        this.G = G;
        this.B = B;
    }
}


// WEBPACK FOOTER //
// ./src/app/uimodels/color.ts